import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-c6ebd3b0"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "no-device-body"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "no-tips"
  }, "检测到屏幕分享未开启，请开启屏幕分享。", -1);
});
var _hoisted_3 = {
  class: "no-action"
};
var _hoisted_4 = /*#__PURE__*/_createTextVNode(" 分享屏幕 ");
import { TrtcService } from '@/services/exam/trtc.service';
import { useService } from '@kaokei/use-vue-service';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    var trtcService = useService(TrtcService);
    var onStartScreenShare = function () {
      trtcService.eventTrack({
        eventName: 'startScreenShare'
      });
      trtcService.initScreenShare();
    };
    return function (_ctx, _cache) {
      var _component_a_button = _resolveComponent("a-button");
      var _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        visible: _unref(trtcService).showScreenShareTips,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return _unref(trtcService).showScreenShareTips = $event;
        }),
        closable: true,
        "destroy-on-close": true,
        "mask-closable": false,
        keyboard: false,
        width: 523,
        title: null,
        footer: null,
        centered: "",
        class: "no-device-dialog"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_a_button, {
            class: "btn",
            type: "primary",
            onClick: onStartScreenShare
          }, {
            default: _withCtx(function () {
              return [_hoisted_4];
            }),
            _: 1
          })])])];
        }),
        _: 1
      }, 8, ["visible"]);
    };
  }
});